/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import * as Consts from "./consts";
import { IServerTimeState, ServerTimeActionsTypes } from "./types";

export const initialState: IServerTimeState = {
  isLoading: false,
};

export const serverTimeReducer = (
  state = initialState,
  action: ServerTimeActionsTypes,
): IServerTimeState => {
  switch (action.type) {
    case Consts.GET_SERVER_TIME: {
      return {
        ...state,
        action,
        error: undefined,
        isLoading: true,
      };
    }
    case Consts.GET_SERVER_TIME_SUCCESS: {
      return {
        ...state,
        action,
        apiVersion: action.payload.apiVersion,
        error: undefined,
        isLoading: false,
        performanceTimeMs: action.payload.performanceTimeMs,
        serverDateTimeOffset: action.payload.serverDateTimeOffset,
        serverTimeMs: action.payload.serverTimeMs,
      };
    }
    case Consts.GET_SERVER_TIME_FAILURE: {
      return {
        ...state,
        action,
        error: action.error,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
